var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#FFFFFF",
    stroke: "#b99750"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L9 17.1962L9 6.80385L18 12Z",
    fill: "#b99750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconCircle);
export default __webpack_public_path__ + "static/media/play-icon-circle.7efe3cb2aa052f6f84989ed095aaeb3e.svg";
export { ForwardRef as ReactComponent };